import {FeatureFlag} from '../../APIs/flagrAPI/types';

function getFeatureFlag(key: string) {
  const storedFlags = sessionStorage.getItem('featureFlags');
  const jsonFlags: FeatureFlag[] = storedFlags ? JSON.parse(storedFlags) : [];

  const selectedFlag = findFeatureFlag(jsonFlags, key);
  return {...selectedFlag, isOn: selectedFlag?.variantKey === 'on'};
}

export function findFeatureFlag(
  flagList: FeatureFlag[] | undefined,
  key: string,
  variantKey?: string,
) {
  return flagList?.find?.((flag) => {
    if (variantKey) {
      return flag.variantKey === variantKey && flag.flagKey === key;
    }

    return flag.flagKey === key;
  });
}

export function hasStoredFeatureFlags() {
  return !!sessionStorage.getItem('featureFlags');
}

export default getFeatureFlag;
